

import React from 'react'
import styled from 'styled-components'
import { setField, useFieldError, useFieldValue } from '..'
import styles from '../../../common/styles'
import { DPInput } from '../../../common/types'
import UInput from '../../../UI/UInput'

interface Props extends DPInput {}

const Input = (props: Props) => {
	const title = useFieldValue('title')
	const error = useFieldError('title')

	return (
    <Wrapper>
      <UInput.InputEl
				disabled={props.disabled}
        type={"text"}
        placeholder={"Title"}
        value={title}
        onChange={(e) => {
          setField("title", e.target.value);
        }}
      />
      {error && <UInput.ErrorMessage>{error}</UInput.ErrorMessage>}
    </Wrapper>
  );
}

const Wrapper = styled(UInput.Wrapper)(() => [styles.border]);

export default Input